import { gql, useQuery } from "@apollo/client";

import useAuth from "@/hooks/use-auth";

import type { LocationCardGameType } from "../location-card";

const QUERY = gql`
  query Location($id: ID!, $isUser: Boolean!) {
    location(id: $id) {
      id
      company {
        id
        name
        slug
      }
      displayName
      games {
        awards {
          id
        }
        closingAt
        communityRatingCount
        communityScore
        communityScoreBucket
        communityScorePercentages {
          percentage
          rating
        }
        coupons(limit: 1) {
          id
        }
        description
        difficulty
        gameimageSet {
          imageId
        }
        id
        isCompleted @include(if: $isUser)
        isSaved @include(if: $isUser)
        isScary
        kind
        name
        minutes
        openingAt
        overallRating @include(if: $isUser)
        playersMax
        playersMin
        primaryCategory {
          id
          name
          slug
          parent {
            id
            name
            slug
          }
        }
        secondaryCategories {
          id
          name
          slug
        }
        slug
        status
        tags {
          id
        }
      }
      locality {
        locality
      }
      slug
    }
  }
`;

interface LocationType {
  company: {
    name: string;
    slug: string;
  };
  displayName?: string;
  games: LocationCardGameType[];
  locality: {
    locality: string;
  };
  slug: string;
}

interface DataType {
  location: LocationType;
}

interface VariablesType {
  id: string;
  isUser: boolean;
}

export default function useGamesQuery(locationId: string) {
  const { isUser, queryContext } = useAuth();

  return useQuery<DataType, VariablesType>(
    QUERY,
    queryContext({ id: locationId, isUser })
  );
}
